import { DetailsBasicInfoSectionCombinedProps } from './types';

const usePresenter = (props: DetailsBasicInfoSectionCombinedProps): DetailsBasicInfoSectionCombinedProps => {
  return props;
};

export default usePresenter;
